function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// src/index.ts
import { Plugin as Plugin2 } from "prosemirror-state"; // src/cellselection.ts

import { Fragment, Slice } from "prosemirror-model";
import { NodeSelection as NodeSelection2, Selection, SelectionRange, TextSelection } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view"; // src/tablemap.ts

var readFromCache;
var addToCache;

if (typeof WeakMap != "undefined") {
  var cache = /* @__PURE__ */new WeakMap();

  readFromCache = function readFromCache(key) {
    return cache.get(key);
  };

  addToCache = function addToCache(key, value) {
    cache.set(key, value);
    return value;
  };
} else {
  var _cache = [];
  var cacheSize = 10;
  var cachePos = 0;

  readFromCache = function readFromCache(key) {
    for (var i = 0; i < _cache.length; i += 2) {
      if (_cache[i] == key) return _cache[i + 1];
    }
  };

  addToCache = function addToCache(key, value) {
    if (cachePos == cacheSize) cachePos = 0;
    _cache[cachePos++] = key;
    return _cache[cachePos++] = value;
  };
}

var TableMap = /*#__PURE__*/function () {
  function TableMap(width, height, map, problems) {
    _classCallCheck(this, TableMap);

    this.width = width;
    this.height = height;
    this.map = map;
    this.problems = problems;
  } // Find the dimensions of the cell at the given position.


  _createClass(TableMap, [{
    key: "findCell",
    value: function findCell(pos) {
      for (var i = 0; i < this.map.length; i++) {
        var curPos = this.map[i];
        if (curPos != pos) continue;
        var left = i % this.width;
        var top = i / this.width | 0;
        var right = left + 1;
        var bottom = top + 1;

        for (var j = 1; right < this.width && this.map[i + j] == curPos; j++) {
          right++;
        }

        for (var _j = 1; bottom < this.height && this.map[i + this.width * _j] == curPos; _j++) {
          bottom++;
        }

        return {
          left: left,
          top: top,
          right: right,
          bottom: bottom
        };
      }

      throw new RangeError("No cell with offset ".concat(pos, " found"));
    } // Find the left side of the cell at the given position.

  }, {
    key: "colCount",
    value: function colCount(pos) {
      for (var i = 0; i < this.map.length; i++) {
        if (this.map[i] == pos) {
          return i % this.width;
        }
      }

      throw new RangeError("No cell with offset ".concat(pos, " found"));
    } // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.

  }, {
    key: "nextCell",
    value: function nextCell(pos, axis, dir) {
      var _this$findCell = this.findCell(pos),
          left = _this$findCell.left,
          right = _this$findCell.right,
          top = _this$findCell.top,
          bottom = _this$findCell.bottom;

      if (axis == "horiz") {
        if (dir < 0 ? left == 0 : right == this.width) return null;
        return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
      } else {
        if (dir < 0 ? top == 0 : bottom == this.height) return null;
        return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
      }
    } // Get the rectangle spanning the two given cells.

  }, {
    key: "rectBetween",
    value: function rectBetween(a, b) {
      var _this$findCell2 = this.findCell(a),
          leftA = _this$findCell2.left,
          rightA = _this$findCell2.right,
          topA = _this$findCell2.top,
          bottomA = _this$findCell2.bottom;

      var _this$findCell3 = this.findCell(b),
          leftB = _this$findCell3.left,
          rightB = _this$findCell3.right,
          topB = _this$findCell3.top,
          bottomB = _this$findCell3.bottom;

      return {
        left: Math.min(leftA, leftB),
        top: Math.min(topA, topB),
        right: Math.max(rightA, rightB),
        bottom: Math.max(bottomA, bottomB)
      };
    } // Return the position of all cells that have the top left corner in
    // the given rectangle.

  }, {
    key: "cellsInRect",
    value: function cellsInRect(rect) {
      var result = [];
      var seen = {};

      for (var row = rect.top; row < rect.bottom; row++) {
        for (var col = rect.left; col < rect.right; col++) {
          var index = row * this.width + col;
          var pos = this.map[index];
          if (seen[pos]) continue;
          seen[pos] = true;

          if (col == rect.left && col && this.map[index - 1] == pos || row == rect.top && row && this.map[index - this.width] == pos) {
            continue;
          }

          result.push(pos);
        }
      }

      return result;
    } // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.

  }, {
    key: "positionAt",
    value: function positionAt(row, col, table) {
      for (var i = 0, rowStart = 0;; i++) {
        var rowEnd = rowStart + table.child(i).nodeSize;

        if (i == row) {
          var index = col + row * this.width;
          var rowEndIndex = (row + 1) * this.width;

          while (index < rowEndIndex && this.map[index] < rowStart) {
            index++;
          }

          return index == rowEndIndex ? rowEnd - 1 : this.map[index];
        }

        rowStart = rowEnd;
      }
    } // Find the table map for the given table node.

  }], [{
    key: "get",
    value: function get(table) {
      return readFromCache(table) || addToCache(table, computeMap(table));
    }
  }]);

  return TableMap;
}();

function computeMap(table) {
  if (table.type.spec.tableRole != "table") throw new RangeError("Not a table node: " + table.type.name);
  var width = findWidth(table),
      height = table.childCount;
  var map = [];
  var mapPos = 0;
  var problems = null;
  var colWidths = [];

  for (var i = 0, e = width * height; i < e; i++) {
    map[i] = 0;
  }

  for (var row = 0, pos = 0; row < height; row++) {
    var rowNode = table.child(row);
    pos++;

    for (var _i = 0;; _i++) {
      while (mapPos < map.length && map[mapPos] != 0) {
        mapPos++;
      }

      if (_i == rowNode.childCount) break;
      var cellNode = rowNode.child(_i);
      var _cellNode$attrs = cellNode.attrs,
          colspan = _cellNode$attrs.colspan,
          rowspan = _cellNode$attrs.rowspan,
          colwidth = _cellNode$attrs.colwidth;

      for (var h = 0; h < rowspan; h++) {
        if (h + row >= height) {
          (problems || (problems = [])).push({
            type: "overlong_rowspan",
            pos: pos,
            n: rowspan - h
          });
          break;
        }

        var start = mapPos + h * width;

        for (var w = 0; w < colspan; w++) {
          if (map[start + w] == 0) map[start + w] = pos;else (problems || (problems = [])).push({
            type: "collision",
            row: row,
            pos: pos,
            n: colspan - w
          });
          var colW = colwidth && colwidth[w];

          if (colW) {
            var widthIndex = (start + w) % width * 2,
                prev = colWidths[widthIndex];

            if (prev == null || prev != colW && colWidths[widthIndex + 1] == 1) {
              colWidths[widthIndex] = colW;
              colWidths[widthIndex + 1] = 1;
            } else if (prev == colW) {
              colWidths[widthIndex + 1]++;
            }
          }
        }
      }

      mapPos += colspan;
      pos += cellNode.nodeSize;
    }

    var expectedPos = (row + 1) * width;
    var missing = 0;

    while (mapPos < expectedPos) {
      if (map[mapPos++] == 0) missing++;
    }

    if (missing) (problems || (problems = [])).push({
      type: "missing",
      row: row,
      n: missing
    });
    pos++;
  }

  if (width === 0 || height === 0) (problems || (problems = [])).push({
    type: "zero_sized"
  });
  var tableMap = new TableMap(width, height, map, problems);
  var badWidths = false;

  for (var _i2 = 0; !badWidths && _i2 < colWidths.length; _i2 += 2) {
    if (colWidths[_i2] != null && colWidths[_i2 + 1] < height) badWidths = true;
  }

  if (badWidths) findBadColWidths(tableMap, colWidths, table);
  return tableMap;
}

function findWidth(table) {
  var width = -1;
  var hasRowSpan = false;

  for (var row = 0; row < table.childCount; row++) {
    var rowNode = table.child(row);
    var rowWidth = 0;
    if (hasRowSpan) for (var j = 0; j < row; j++) {
      var prevRow = table.child(j);

      for (var i = 0; i < prevRow.childCount; i++) {
        var cell = prevRow.child(i);
        if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
      }
    }

    for (var _i3 = 0; _i3 < rowNode.childCount; _i3++) {
      var _cell = rowNode.child(_i3);

      rowWidth += _cell.attrs.colspan;
      if (_cell.attrs.rowspan > 1) hasRowSpan = true;
    }

    if (width == -1) width = rowWidth;else if (width != rowWidth) width = Math.max(width, rowWidth);
  }

  return width;
}

function findBadColWidths(map, colWidths, table) {
  if (!map.problems) map.problems = [];
  var seen = {};

  for (var i = 0; i < map.map.length; i++) {
    var pos = map.map[i];
    if (seen[pos]) continue;
    seen[pos] = true;
    var node = table.nodeAt(pos);

    if (!node) {
      throw new RangeError("No cell with offset ".concat(pos, " found"));
    }

    var updated = null;
    var attrs = node.attrs;

    for (var j = 0; j < attrs.colspan; j++) {
      var col = (i + j) % map.width;
      var colWidth = colWidths[col * 2];
      if (colWidth != null && (!attrs.colwidth || attrs.colwidth[j] != colWidth)) (updated || (updated = freshColWidth(attrs)))[j] = colWidth;
    }

    if (updated) map.problems.unshift({
      type: "colwidth mismatch",
      pos: pos,
      colwidth: updated
    });
  }
}

function freshColWidth(attrs) {
  if (attrs.colwidth) return attrs.colwidth.slice();
  var result = [];

  for (var i = 0; i < attrs.colspan; i++) {
    result.push(0);
  }

  return result;
} // src/util.ts


import { PluginKey } from "prosemirror-state"; // src/schema.ts

function getCellAttrs(dom, extraAttrs) {
  if (typeof dom === "string") {
    return {};
  }

  var widthAttr = dom.getAttribute("data-colwidth");
  var widths = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(",").map(function (s) {
    return Number(s);
  }) : null;
  var colspan = Number(dom.getAttribute("colspan") || 1);
  var result = {
    colspan: colspan,
    rowspan: Number(dom.getAttribute("rowspan") || 1),
    colwidth: widths && widths.length == colspan ? widths : null
  };

  for (var prop in extraAttrs) {
    var getter = extraAttrs[prop].getFromDOM;
    var value = getter && getter(dom);

    if (value != null) {
      result[prop] = value;
    }
  }

  return result;
}

function setCellAttrs(node, extraAttrs) {
  var attrs = {};
  if (node.attrs.colspan != 1) attrs.colspan = node.attrs.colspan;
  if (node.attrs.rowspan != 1) attrs.rowspan = node.attrs.rowspan;
  if (node.attrs.colwidth) attrs["data-colwidth"] = node.attrs.colwidth.join(",");

  for (var prop in extraAttrs) {
    var setter = extraAttrs[prop].setDOMAttr;
    if (setter) setter(node.attrs[prop], attrs);
  }

  return attrs;
}

function tableNodes(options) {
  var extraAttrs = options.cellAttributes || {};
  var cellAttrs = {
    colspan: {
      default: 1
    },
    rowspan: {
      default: 1
    },
    colwidth: {
      default: null
    }
  };

  for (var prop in extraAttrs) {
    cellAttrs[prop] = {
      default: extraAttrs[prop].default
    };
  }

  return {
    table: {
      content: "table_row+",
      tableRole: "table",
      isolating: true,
      group: options.tableGroup,
      parseDOM: [{
        tag: "table"
      }],
      toDOM: function toDOM() {
        return ["table", ["tbody", 0]];
      }
    },
    table_row: {
      content: "(table_cell | table_header)*",
      tableRole: "row",
      parseDOM: [{
        tag: "tr"
      }],
      toDOM: function toDOM() {
        return ["tr", 0];
      }
    },
    table_cell: {
      content: options.cellContent,
      attrs: cellAttrs,
      tableRole: "cell",
      isolating: true,
      parseDOM: [{
        tag: "td",
        getAttrs: function getAttrs(dom) {
          return getCellAttrs(dom, extraAttrs);
        }
      }],
      toDOM: function toDOM(node) {
        return ["td", setCellAttrs(node, extraAttrs), 0];
      }
    },
    table_header: {
      content: options.cellContent,
      attrs: cellAttrs,
      tableRole: "header_cell",
      isolating: true,
      parseDOM: [{
        tag: "th",
        getAttrs: function getAttrs(dom) {
          return getCellAttrs(dom, extraAttrs);
        }
      }],
      toDOM: function toDOM(node) {
        return ["th", setCellAttrs(node, extraAttrs), 0];
      }
    }
  };
}

function tableNodeTypes(schema) {
  var result = schema.cached.tableNodeTypes;

  if (!result) {
    result = schema.cached.tableNodeTypes = {};

    for (var name in schema.nodes) {
      var type = schema.nodes[name],
          role = type.spec.tableRole;
      if (role) result[role] = type;
    }
  }

  return result;
} // src/util.ts


var tableEditingKey = new PluginKey("selectingCells");

function cellAround($pos) {
  for (var d = $pos.depth - 1; d > 0; d--) {
    if ($pos.node(d).type.spec.tableRole == "row") return $pos.node(0).resolve($pos.before(d + 1));
  }

  return null;
}

function cellWrapping($pos) {
  for (var d = $pos.depth; d > 0; d--) {
    var role = $pos.node(d).type.spec.tableRole;
    if (role === "cell" || role === "header_cell") return $pos.node(d);
  }

  return null;
}

function isInTable(state) {
  var $head = state.selection.$head;

  for (var d = $head.depth; d > 0; d--) {
    if ($head.node(d).type.spec.tableRole == "row") return true;
  }

  return false;
}

function selectionCell(state) {
  var sel = state.selection;

  if ("$anchorCell" in sel && sel.$anchorCell) {
    return sel.$anchorCell.pos > sel.$headCell.pos ? sel.$anchorCell : sel.$headCell;
  } else if ("node" in sel && sel.node && sel.node.type.spec.tableRole == "cell") {
    return sel.$anchor;
  }

  var $cell = cellAround(sel.$head) || cellNear(sel.$head);

  if ($cell) {
    return $cell;
  }

  throw new RangeError("No cell found around position ".concat(sel.head));
}

function cellNear($pos) {
  for (var after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++) {
    var role = after.type.spec.tableRole;
    if (role == "cell" || role == "header_cell") return $pos.doc.resolve(pos);
  }

  for (var before = $pos.nodeBefore, _pos = $pos.pos; before; before = before.lastChild, _pos--) {
    var _role = before.type.spec.tableRole;
    if (_role == "cell" || _role == "header_cell") return $pos.doc.resolve(_pos - before.nodeSize);
  }
}

function pointsAtCell($pos) {
  return $pos.parent.type.spec.tableRole == "row" && !!$pos.nodeAfter;
}

function moveCellForward($pos) {
  return $pos.node(0).resolve($pos.pos + $pos.nodeAfter.nodeSize);
}

function inSameTable($cellA, $cellB) {
  return $cellA.depth == $cellB.depth && $cellA.pos >= $cellB.start(-1) && $cellA.pos <= $cellB.end(-1);
}

function findCell($pos) {
  return TableMap.get($pos.node(-1)).findCell($pos.pos - $pos.start(-1));
}

function colCount($pos) {
  return TableMap.get($pos.node(-1)).colCount($pos.pos - $pos.start(-1));
}

function nextCell($pos, axis, dir) {
  var table = $pos.node(-1);
  var map = TableMap.get(table);
  var tableStart = $pos.start(-1);
  var moved = map.nextCell($pos.pos - tableStart, axis, dir);
  return moved == null ? null : $pos.node(0).resolve(tableStart + moved);
}

function removeColSpan(attrs, pos) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var result = _objectSpread(_objectSpread({}, attrs), {}, {
    colspan: attrs.colspan - n
  });

  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    result.colwidth.splice(pos, n);
    if (!result.colwidth.some(function (w) {
      return w > 0;
    })) result.colwidth = null;
  }

  return result;
}

function addColSpan(attrs, pos) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var result = _objectSpread(_objectSpread({}, attrs), {}, {
    colspan: attrs.colspan + n
  });

  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();

    for (var i = 0; i < n; i++) {
      result.colwidth.splice(pos, 0, 0);
    }
  }

  return result;
}

function columnIsHeader(map, table, col) {
  var headerCell = tableNodeTypes(table.type.schema).header_cell;

  for (var row = 0; row < map.height; row++) {
    if (table.nodeAt(map.map[col + row * map.width]).type != headerCell) return false;
  }

  return true;
} // src/cellselection.ts


var CellSelection = /*#__PURE__*/function (_Selection) {
  _inherits(_CellSelection, _Selection);

  var _super = _createSuper(_CellSelection);

  // A table selection is identified by its anchor and head cells. The
  // positions given to this constructor should point _before_ two
  // cells in the same table. They may be the same, to select a single
  // cell.
  function _CellSelection($anchorCell) {
    var _this;

    var $headCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchorCell;

    _classCallCheck(this, _CellSelection);

    var table = $anchorCell.node(-1);
    var map = TableMap.get(table);
    var tableStart = $anchorCell.start(-1);
    var rect = map.rectBetween($anchorCell.pos - tableStart, $headCell.pos - tableStart);
    var doc = $anchorCell.node(0);
    var cells = map.cellsInRect(rect).filter(function (p) {
      return p != $headCell.pos - tableStart;
    });
    cells.unshift($headCell.pos - tableStart);
    var ranges = cells.map(function (pos) {
      var cell = table.nodeAt(pos);

      if (!cell) {
        throw RangeError("No cell with offset ".concat(pos, " found"));
      }

      var from = tableStart + pos + 1;
      return new SelectionRange(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
    _this = _super.call(this, ranges[0].$from, ranges[0].$to, ranges);
    _this.$anchorCell = $anchorCell;
    _this.$headCell = $headCell;
    return _this;
  }

  _createClass(_CellSelection, [{
    key: "map",
    value: function map(doc, mapping) {
      var $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
      var $headCell = doc.resolve(mapping.map(this.$headCell.pos));

      if (pointsAtCell($anchorCell) && pointsAtCell($headCell) && inSameTable($anchorCell, $headCell)) {
        var tableChanged = this.$anchorCell.node(-1) != $anchorCell.node(-1);
        if (tableChanged && this.isRowSelection()) return _CellSelection.rowSelection($anchorCell, $headCell);else if (tableChanged && this.isColSelection()) return _CellSelection.colSelection($anchorCell, $headCell);else return new _CellSelection($anchorCell, $headCell);
      }

      return TextSelection.between($anchorCell, $headCell);
    } // Returns a rectangular slice of table rows containing the selected
    // cells.

  }, {
    key: "content",
    value: function content() {
      var table = this.$anchorCell.node(-1);
      var map = TableMap.get(table);
      var tableStart = this.$anchorCell.start(-1);
      var rect = map.rectBetween(this.$anchorCell.pos - tableStart, this.$headCell.pos - tableStart);
      var seen = {};
      var rows = [];

      for (var row = rect.top; row < rect.bottom; row++) {
        var rowContent = [];

        for (var index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++) {
          var pos = map.map[index];
          if (seen[pos]) continue;
          seen[pos] = true;
          var cellRect = map.findCell(pos);
          var cell = table.nodeAt(pos);

          if (!cell) {
            throw RangeError("No cell with offset ".concat(pos, " found"));
          }

          var extraLeft = rect.left - cellRect.left;
          var extraRight = cellRect.right - rect.right;

          if (extraLeft > 0 || extraRight > 0) {
            var attrs = cell.attrs;

            if (extraLeft > 0) {
              attrs = removeColSpan(attrs, 0, extraLeft);
            }

            if (extraRight > 0) {
              attrs = removeColSpan(attrs, attrs.colspan - extraRight, extraRight);
            }

            if (cellRect.left < rect.left) {
              cell = cell.type.createAndFill(attrs);

              if (!cell) {
                throw RangeError("Could not create cell with attrs ".concat(JSON.stringify(attrs)));
              }
            } else {
              cell = cell.type.create(attrs, cell.content);
            }
          }

          if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
            var _attrs = _objectSpread(_objectSpread({}, cell.attrs), {}, {
              rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
            });

            if (cellRect.top < rect.top) {
              cell = cell.type.createAndFill(_attrs);
            } else {
              cell = cell.type.create(_attrs, cell.content);
            }
          }

          rowContent.push(cell);
        }

        rows.push(table.child(row).copy(Fragment.from(rowContent)));
      }

      var fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
      return new Slice(Fragment.from(fragment), 1, 1);
    }
  }, {
    key: "replace",
    value: function replace(tr) {
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Slice.empty;
      var mapFrom = tr.steps.length,
          ranges = this.ranges;

      for (var i = 0; i < ranges.length; i++) {
        var _ranges$i = ranges[i],
            $from = _ranges$i.$from,
            $to = _ranges$i.$to,
            mapping = tr.mapping.slice(mapFrom);
        tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? Slice.empty : content);
      }

      var sel = Selection.findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
      if (sel) tr.setSelection(sel);
    }
  }, {
    key: "replaceWith",
    value: function replaceWith(tr, node) {
      this.replace(tr, new Slice(Fragment.from(node), 0, 0));
    }
  }, {
    key: "forEachCell",
    value: function forEachCell(f) {
      var table = this.$anchorCell.node(-1);
      var map = TableMap.get(table);
      var tableStart = this.$anchorCell.start(-1);
      var cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - tableStart, this.$headCell.pos - tableStart));

      for (var i = 0; i < cells.length; i++) {
        f(table.nodeAt(cells[i]), tableStart + cells[i]);
      }
    } // True if this selection goes all the way from the top to the
    // bottom of the table.

  }, {
    key: "isColSelection",
    value: function isColSelection() {
      var anchorTop = this.$anchorCell.index(-1);
      var headTop = this.$headCell.index(-1);
      if (Math.min(anchorTop, headTop) > 0) return false;
      var anchorBottom = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
      var headBottom = headTop + this.$headCell.nodeAfter.attrs.rowspan;
      return Math.max(anchorBottom, headBottom) == this.$headCell.node(-1).childCount;
    } // Returns the smallest column selection that covers the given anchor
    // and head cell.

  }, {
    key: "isRowSelection",
    value: // True if this selection goes all the way from the left to the
    // right of the table.
    function isRowSelection() {
      var table = this.$anchorCell.node(-1);
      var map = TableMap.get(table);
      var tableStart = this.$anchorCell.start(-1);
      var anchorLeft = map.colCount(this.$anchorCell.pos - tableStart);
      var headLeft = map.colCount(this.$headCell.pos - tableStart);
      if (Math.min(anchorLeft, headLeft) > 0) return false;
      var anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
      var headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
      return Math.max(anchorRight, headRight) == map.width;
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return other instanceof _CellSelection && other.$anchorCell.pos == this.$anchorCell.pos && other.$headCell.pos == this.$headCell.pos;
    } // Returns the smallest row selection that covers the given anchor
    // and head cell.

  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        type: "cell",
        anchor: this.$anchorCell.pos,
        head: this.$headCell.pos
      };
    }
  }, {
    key: "getBookmark",
    value: function getBookmark() {
      return new CellBookmark(this.$anchorCell.pos, this.$headCell.pos);
    }
  }], [{
    key: "colSelection",
    value: function colSelection($anchorCell) {
      var $headCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchorCell;
      var table = $anchorCell.node(-1);
      var map = TableMap.get(table);
      var tableStart = $anchorCell.start(-1);
      var anchorRect = map.findCell($anchorCell.pos - tableStart);
      var headRect = map.findCell($headCell.pos - tableStart);
      var doc = $anchorCell.node(0);

      if (anchorRect.top <= headRect.top) {
        if (anchorRect.top > 0) $anchorCell = doc.resolve(tableStart + map.map[anchorRect.left]);
        if (headRect.bottom < map.height) $headCell = doc.resolve(tableStart + map.map[map.width * (map.height - 1) + headRect.right - 1]);
      } else {
        if (headRect.top > 0) $headCell = doc.resolve(tableStart + map.map[headRect.left]);
        if (anchorRect.bottom < map.height) $anchorCell = doc.resolve(tableStart + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
      }

      return new _CellSelection($anchorCell, $headCell);
    }
  }, {
    key: "rowSelection",
    value: function rowSelection($anchorCell) {
      var $headCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchorCell;
      var table = $anchorCell.node(-1);
      var map = TableMap.get(table);
      var tableStart = $anchorCell.start(-1);
      var anchorRect = map.findCell($anchorCell.pos - tableStart);
      var headRect = map.findCell($headCell.pos - tableStart);
      var doc = $anchorCell.node(0);

      if (anchorRect.left <= headRect.left) {
        if (anchorRect.left > 0) $anchorCell = doc.resolve(tableStart + map.map[anchorRect.top * map.width]);
        if (headRect.right < map.width) $headCell = doc.resolve(tableStart + map.map[map.width * (headRect.top + 1) - 1]);
      } else {
        if (headRect.left > 0) $headCell = doc.resolve(tableStart + map.map[headRect.top * map.width]);
        if (anchorRect.right < map.width) $anchorCell = doc.resolve(tableStart + map.map[map.width * (anchorRect.top + 1) - 1]);
      }

      return new _CellSelection($anchorCell, $headCell);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(doc, json) {
      return new _CellSelection(doc.resolve(json.anchor), doc.resolve(json.head));
    }
  }, {
    key: "create",
    value: function create(doc, anchorCell) {
      var headCell = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : anchorCell;
      return new _CellSelection(doc.resolve(anchorCell), doc.resolve(headCell));
    }
  }]);

  return _CellSelection;
}(Selection);

CellSelection.prototype.visible = false;
Selection.jsonID("cell", CellSelection);

var CellBookmark = /*#__PURE__*/function () {
  function _CellBookmark(anchor, head) {
    _classCallCheck(this, _CellBookmark);

    this.anchor = anchor;
    this.head = head;
  }

  _createClass(_CellBookmark, [{
    key: "map",
    value: function map(mapping) {
      return new _CellBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
  }, {
    key: "resolve",
    value: function resolve(doc) {
      var $anchorCell = doc.resolve(this.anchor),
          $headCell = doc.resolve(this.head);
      if ($anchorCell.parent.type.spec.tableRole == "row" && $headCell.parent.type.spec.tableRole == "row" && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && inSameTable($anchorCell, $headCell)) return new CellSelection($anchorCell, $headCell);else return Selection.near($headCell, 1);
    }
  }]);

  return _CellBookmark;
}();

function drawCellSelection(state) {
  if (!(state.selection instanceof CellSelection)) return null;
  var cells = [];
  state.selection.forEachCell(function (node, pos) {
    cells.push(Decoration.node(pos, pos + node.nodeSize, {
      class: "selectedCell"
    }));
  });
  return DecorationSet.create(state.doc, cells);
}

function isCellBoundarySelection(_ref) {
  var $from = _ref.$from,
      $to = _ref.$to;
  if ($from.pos == $to.pos || $from.pos < $to.pos - 6) return false;
  var afterFrom = $from.pos;
  var beforeTo = $to.pos;
  var depth = $from.depth;

  for (; depth >= 0; depth--, afterFrom++) {
    if ($from.after(depth + 1) < $from.end(depth)) break;
  }

  for (var d = $to.depth; d >= 0; d--, beforeTo--) {
    if ($to.before(d + 1) > $to.start(d)) break;
  }

  return afterFrom == beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole);
}

function isTextSelectionAcrossCells(_ref2) {
  var $from = _ref2.$from,
      $to = _ref2.$to;
  var fromCellBoundaryNode;
  var toCellBoundaryNode;

  for (var i = $from.depth; i > 0; i--) {
    var node = $from.node(i);

    if (node.type.spec.tableRole === "cell" || node.type.spec.tableRole === "header_cell") {
      fromCellBoundaryNode = node;
      break;
    }
  }

  for (var _i4 = $to.depth; _i4 > 0; _i4--) {
    var _node = $to.node(_i4);

    if (_node.type.spec.tableRole === "cell" || _node.type.spec.tableRole === "header_cell") {
      toCellBoundaryNode = _node;
      break;
    }
  }

  return fromCellBoundaryNode !== toCellBoundaryNode && $to.parentOffset === 0;
}

function normalizeSelection(state, tr, allowTableNodeSelection) {
  var sel = (tr || state).selection;
  var doc = (tr || state).doc;
  var normalize;
  var role;

  if (sel instanceof NodeSelection2 && (role = sel.node.type.spec.tableRole)) {
    if (role == "cell" || role == "header_cell") {
      normalize = CellSelection.create(doc, sel.from);
    } else if (role == "row") {
      var $cell = doc.resolve(sel.from + 1);
      normalize = CellSelection.rowSelection($cell, $cell);
    } else if (!allowTableNodeSelection) {
      var map = TableMap.get(sel.node);
      var start = sel.from + 1;
      var lastCell = start + map.map[map.width * map.height - 1];
      normalize = CellSelection.create(doc, start + 1, lastCell);
    }
  } else if (sel instanceof TextSelection && isCellBoundarySelection(sel)) {
    normalize = TextSelection.create(doc, sel.from);
  } else if (sel instanceof TextSelection && isTextSelectionAcrossCells(sel)) {
    normalize = TextSelection.create(doc, sel.$from.start(), sel.$from.end());
  }

  if (normalize) (tr || (tr = state.tr)).setSelection(normalize);
  return tr;
} // src/fixtables.ts


import { PluginKey as PluginKey2 } from "prosemirror-state";
var fixTablesKey = new PluginKey2("fix-tables");

function changedDescendants(old, cur, offset, f) {
  var oldSize = old.childCount,
      curSize = cur.childCount;

  outer: for (var i = 0, j = 0; i < curSize; i++) {
    var child = cur.child(i);

    for (var scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++) {
      if (old.child(scan) == child) {
        j = scan + 1;
        offset += child.nodeSize;
        continue outer;
      }
    }

    f(child, offset);
    if (j < oldSize && old.child(j).sameMarkup(child)) changedDescendants(old.child(j), child, offset + 1, f);else child.nodesBetween(0, child.content.size, f, offset + 1);
    offset += child.nodeSize;
  }
}

function fixTables(state, oldState) {
  var tr;

  var check = function check(node, pos) {
    if (node.type.spec.tableRole == "table") tr = fixTable(state, node, pos, tr);
  };

  if (!oldState) state.doc.descendants(check);else if (oldState.doc != state.doc) changedDescendants(oldState.doc, state.doc, 0, check);
  return tr;
}

function fixTable(state, table, tablePos, tr) {
  var map = TableMap.get(table);
  if (!map.problems) return tr;
  if (!tr) tr = state.tr;
  var mustAdd = [];

  for (var i = 0; i < map.height; i++) {
    mustAdd.push(0);
  }

  for (var _i5 = 0; _i5 < map.problems.length; _i5++) {
    var prob = map.problems[_i5];

    if (prob.type == "collision") {
      var cell = table.nodeAt(prob.pos);
      if (!cell) continue;
      var attrs = cell.attrs;

      for (var j = 0; j < attrs.rowspan; j++) {
        mustAdd[prob.row + j] += prob.n;
      }

      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, removeColSpan(attrs, attrs.colspan - prob.n, prob.n));
    } else if (prob.type == "missing") {
      mustAdd[prob.row] += prob.n;
    } else if (prob.type == "overlong_rowspan") {
      var _cell2 = table.nodeAt(prob.pos);

      if (!_cell2) continue;
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, _objectSpread(_objectSpread({}, _cell2.attrs), {}, {
        rowspan: _cell2.attrs.rowspan - prob.n
      }));
    } else if (prob.type == "colwidth mismatch") {
      var _cell3 = table.nodeAt(prob.pos);

      if (!_cell3) continue;
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, _objectSpread(_objectSpread({}, _cell3.attrs), {}, {
        colwidth: prob.colwidth
      }));
    } else if (prob.type == "zero_sized") {
      var pos = tr.mapping.map(tablePos);
      tr.delete(pos, pos + table.nodeSize);
    }
  }

  var first, last;

  for (var _i6 = 0; _i6 < mustAdd.length; _i6++) {
    if (mustAdd[_i6]) {
      if (first == null) first = _i6;
      last = _i6;
    }
  }

  for (var _i7 = 0, _pos2 = tablePos + 1; _i7 < map.height; _i7++) {
    var row = table.child(_i7);
    var end = _pos2 + row.nodeSize;
    var add = mustAdd[_i7];

    if (add > 0) {
      var role = "cell";

      if (row.firstChild) {
        role = row.firstChild.type.spec.tableRole;
      }

      var nodes = [];

      for (var _j2 = 0; _j2 < add; _j2++) {
        var node = tableNodeTypes(state.schema)[role].createAndFill();
        if (node) nodes.push(node);
      }

      var side = (_i7 == 0 || first == _i7 - 1) && last == _i7 ? _pos2 + 1 : end - 1;
      tr.insert(tr.mapping.map(side), nodes);
    }

    _pos2 = end;
  }

  return tr.setMeta(fixTablesKey, {
    fixTables: true
  });
} // src/input.ts


import { keydownHandler } from "prosemirror-keymap";
import { Fragment as Fragment4 } from "prosemirror-model";
import { Selection as Selection2, TextSelection as TextSelection3 } from "prosemirror-state"; // src/commands.ts

import { Fragment as Fragment2, Slice as Slice2 } from "prosemirror-model";
import { TextSelection as TextSelection2 } from "prosemirror-state";

function selectedRect(state) {
  var sel = state.selection;
  var $pos = selectionCell(state);
  var table = $pos.node(-1);
  var tableStart = $pos.start(-1);
  var map = TableMap.get(table);
  var rect = sel instanceof CellSelection ? map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart) : map.findCell($pos.pos - tableStart);
  return _objectSpread(_objectSpread({}, rect), {}, {
    tableStart: tableStart,
    map: map,
    table: table
  });
}

function addColumn(tr, _ref3, col) {
  var map = _ref3.map,
      tableStart = _ref3.tableStart,
      table = _ref3.table;
  var refColumn = col > 0 ? -1 : 0;

  if (columnIsHeader(map, table, col + refColumn)) {
    refColumn = col == 0 || col == map.width ? null : 0;
  }

  for (var row = 0; row < map.height; row++) {
    var index = row * map.width + col;

    if (col > 0 && col < map.width && map.map[index - 1] == map.map[index]) {
      var pos = map.map[index];
      var cell = table.nodeAt(pos);
      tr.setNodeMarkup(tr.mapping.map(tableStart + pos), null, addColSpan(cell.attrs, col - map.colCount(pos)));
      row += cell.attrs.rowspan - 1;
    } else {
      var type = refColumn == null ? tableNodeTypes(table.type.schema).cell : table.nodeAt(map.map[index + refColumn]).type;

      var _pos3 = map.positionAt(row, col, table);

      tr.insert(tr.mapping.map(tableStart + _pos3), type.createAndFill());
    }
  }

  return tr;
}

function addColumnBefore(state, dispatch) {
  if (!isInTable(state)) return false;

  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addColumn(state.tr, rect, rect.left));
  }

  return true;
}

function addColumnAfter(state, dispatch) {
  if (!isInTable(state)) return false;

  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addColumn(state.tr, rect, rect.right));
  }

  return true;
}

function removeColumn(tr, _ref4, col) {
  var map = _ref4.map,
      table = _ref4.table,
      tableStart = _ref4.tableStart;
  var mapStart = tr.mapping.maps.length;

  for (var row = 0; row < map.height;) {
    var index = row * map.width + col;
    var pos = map.map[index];
    var cell = table.nodeAt(pos);
    var attrs = cell.attrs;

    if (col > 0 && map.map[index - 1] == pos || col < map.width - 1 && map.map[index + 1] == pos) {
      tr.setNodeMarkup(tr.mapping.slice(mapStart).map(tableStart + pos), null, removeColSpan(attrs, col - map.colCount(pos)));
    } else {
      var start = tr.mapping.slice(mapStart).map(tableStart + pos);
      tr.delete(start, start + cell.nodeSize);
    }

    row += attrs.rowspan;
  }
}

function deleteColumn(state, dispatch) {
  if (!isInTable(state)) return false;

  if (dispatch) {
    var rect = selectedRect(state);
    var tr = state.tr;
    if (rect.left == 0 && rect.right == rect.map.width) return false;

    for (var i = rect.right - 1;; i--) {
      removeColumn(tr, rect, i);
      if (i == rect.left) break;
      var table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;

      if (!table) {
        throw RangeError("No table found");
      }

      rect.table = table;
      rect.map = TableMap.get(table);
    }

    dispatch(tr);
  }

  return true;
}

function rowIsHeader(map, table, row) {
  var _a;

  var headerCell = tableNodeTypes(table.type.schema).header_cell;

  for (var col = 0; col < map.width; col++) {
    if (((_a = table.nodeAt(map.map[col + row * map.width])) == null ? void 0 : _a.type) != headerCell) return false;
  }

  return true;
}

function addRow(tr, _ref5, row) {
  var map = _ref5.map,
      tableStart = _ref5.tableStart,
      table = _ref5.table;

  var _a;

  var rowPos = tableStart;

  for (var i = 0; i < row; i++) {
    rowPos += table.child(i).nodeSize;
  }

  var cells = [];
  var refRow = row > 0 ? -1 : 0;
  if (rowIsHeader(map, table, row + refRow)) refRow = row == 0 || row == map.height ? null : 0;

  for (var col = 0, index = map.width * row; col < map.width; col++, index++) {
    if (row > 0 && row < map.height && map.map[index] == map.map[index - map.width]) {
      var pos = map.map[index];
      var attrs = table.nodeAt(pos).attrs;
      tr.setNodeMarkup(tableStart + pos, null, _objectSpread(_objectSpread({}, attrs), {}, {
        rowspan: attrs.rowspan + 1
      }));
      col += attrs.colspan - 1;
    } else {
      var type = refRow == null ? tableNodeTypes(table.type.schema).cell : (_a = table.nodeAt(map.map[index + refRow * map.width])) == null ? void 0 : _a.type;
      var node = type == null ? void 0 : type.createAndFill();
      if (node) cells.push(node);
    }
  }

  tr.insert(rowPos, tableNodeTypes(table.type.schema).row.create(null, cells));
  return tr;
}

function addRowBefore(state, dispatch) {
  if (!isInTable(state)) return false;

  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addRow(state.tr, rect, rect.top));
  }

  return true;
}

function addRowAfter(state, dispatch) {
  if (!isInTable(state)) return false;

  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addRow(state.tr, rect, rect.bottom));
  }

  return true;
}

function removeRow(tr, _ref6, row) {
  var map = _ref6.map,
      table = _ref6.table,
      tableStart = _ref6.tableStart;
  var rowPos = 0;

  for (var i = 0; i < row; i++) {
    rowPos += table.child(i).nodeSize;
  }

  var nextRow = rowPos + table.child(row).nodeSize;
  var mapFrom = tr.mapping.maps.length;
  tr.delete(rowPos + tableStart, nextRow + tableStart);
  var seen = /* @__PURE__ */new Set();

  for (var col = 0, index = row * map.width; col < map.width; col++, index++) {
    var pos = map.map[index];
    if (seen.has(pos)) continue;
    seen.add(pos);

    if (row > 0 && pos == map.map[index - map.width]) {
      var attrs = table.nodeAt(pos).attrs;
      tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + tableStart), null, _objectSpread(_objectSpread({}, attrs), {}, {
        rowspan: attrs.rowspan - 1
      }));
      col += attrs.colspan - 1;
    } else if (row < map.height && pos == map.map[index + map.width]) {
      var cell = table.nodeAt(pos);
      var _attrs2 = cell.attrs;
      var copy = cell.type.create(_objectSpread(_objectSpread({}, _attrs2), {}, {
        rowspan: cell.attrs.rowspan - 1
      }), cell.content);
      var newPos = map.positionAt(row + 1, col, table);
      tr.insert(tr.mapping.slice(mapFrom).map(tableStart + newPos), copy);
      col += _attrs2.colspan - 1;
    }
  }
}

function deleteRow(state, dispatch) {
  if (!isInTable(state)) return false;

  if (dispatch) {
    var rect = selectedRect(state),
        tr = state.tr;
    if (rect.top == 0 && rect.bottom == rect.map.height) return false;

    for (var i = rect.bottom - 1;; i--) {
      removeRow(tr, rect, i);
      if (i == rect.top) break;
      var table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;

      if (!table) {
        throw RangeError("No table found");
      }

      rect.table = table;
      rect.map = TableMap.get(rect.table);
    }

    dispatch(tr);
  }

  return true;
}

function isEmpty(cell) {
  var c = cell.content;
  return c.childCount == 1 && c.child(0).isTextblock && c.child(0).childCount == 0;
}

function cellsOverlapRectangle(_ref7, rect) {
  var width = _ref7.width,
      height = _ref7.height,
      map = _ref7.map;
  var indexTop = rect.top * width + rect.left,
      indexLeft = indexTop;
  var indexBottom = (rect.bottom - 1) * width + rect.left,
      indexRight = indexTop + (rect.right - rect.left - 1);

  for (var i = rect.top; i < rect.bottom; i++) {
    if (rect.left > 0 && map[indexLeft] == map[indexLeft - 1] || rect.right < width && map[indexRight] == map[indexRight + 1]) return true;
    indexLeft += width;
    indexRight += width;
  }

  for (var _i8 = rect.left; _i8 < rect.right; _i8++) {
    if (rect.top > 0 && map[indexTop] == map[indexTop - width] || rect.bottom < height && map[indexBottom] == map[indexBottom + width]) return true;
    indexTop++;
    indexBottom++;
  }

  return false;
}

function mergeCells(state, dispatch) {
  var sel = state.selection;
  if (!(sel instanceof CellSelection) || sel.$anchorCell.pos == sel.$headCell.pos) return false;
  var rect = selectedRect(state),
      map = rect.map;
  if (cellsOverlapRectangle(map, rect)) return false;

  if (dispatch) {
    var tr = state.tr;
    var seen = {};
    var content = Fragment2.empty;
    var mergedPos;
    var mergedCell;

    for (var row = rect.top; row < rect.bottom; row++) {
      for (var col = rect.left; col < rect.right; col++) {
        var cellPos = map.map[row * map.width + col];
        var cell = rect.table.nodeAt(cellPos);
        if (seen[cellPos] || !cell) continue;
        seen[cellPos] = true;

        if (mergedPos == null) {
          mergedPos = cellPos;
          mergedCell = cell;
        } else {
          if (!isEmpty(cell)) content = content.append(cell.content);
          var mapped = tr.mapping.map(cellPos + rect.tableStart);
          tr.delete(mapped, mapped + cell.nodeSize);
        }
      }
    }

    if (mergedPos == null || mergedCell == null) {
      return true;
    }

    tr.setNodeMarkup(mergedPos + rect.tableStart, null, _objectSpread(_objectSpread({}, addColSpan(mergedCell.attrs, mergedCell.attrs.colspan, rect.right - rect.left - mergedCell.attrs.colspan)), {}, {
      rowspan: rect.bottom - rect.top
    }));

    if (content.size) {
      var end = mergedPos + 1 + mergedCell.content.size;
      var start = isEmpty(mergedCell) ? mergedPos + 1 : end;
      tr.replaceWith(start + rect.tableStart, end + rect.tableStart, content);
    }

    tr.setSelection(new CellSelection(tr.doc.resolve(mergedPos + rect.tableStart)));
    dispatch(tr);
  }

  return true;
}

function splitCell(state, dispatch) {
  var nodeTypes = tableNodeTypes(state.schema);
  return splitCellWithType(function (_ref8) {
    var node = _ref8.node;
    return nodeTypes[node.type.spec.tableRole];
  })(state, dispatch);
}

function splitCellWithType(getCellType) {
  return function (state, dispatch) {
    var _a;

    var sel = state.selection;
    var cellNode;
    var cellPos;

    if (!(sel instanceof CellSelection)) {
      cellNode = cellWrapping(sel.$from);
      if (!cellNode) return false;
      cellPos = (_a = cellAround(sel.$from)) == null ? void 0 : _a.pos;
    } else {
      if (sel.$anchorCell.pos != sel.$headCell.pos) return false;
      cellNode = sel.$anchorCell.nodeAfter;
      cellPos = sel.$anchorCell.pos;
    }

    if (cellNode == null || cellPos == null) {
      return false;
    }

    if (cellNode.attrs.colspan == 1 && cellNode.attrs.rowspan == 1) {
      return false;
    }

    if (dispatch) {
      var baseAttrs = cellNode.attrs;
      var attrs = [];
      var colwidth = baseAttrs.colwidth;
      if (baseAttrs.rowspan > 1) baseAttrs = _objectSpread(_objectSpread({}, baseAttrs), {}, {
        rowspan: 1
      });
      if (baseAttrs.colspan > 1) baseAttrs = _objectSpread(_objectSpread({}, baseAttrs), {}, {
        colspan: 1
      });
      var rect = selectedRect(state),
          tr = state.tr;

      for (var i = 0; i < rect.right - rect.left; i++) {
        attrs.push(colwidth ? _objectSpread(_objectSpread({}, baseAttrs), {}, {
          colwidth: colwidth && colwidth[i] ? [colwidth[i]] : null
        }) : baseAttrs);
      }

      var lastCell;

      for (var row = rect.top; row < rect.bottom; row++) {
        var pos = rect.map.positionAt(row, rect.left, rect.table);
        if (row == rect.top) pos += cellNode.nodeSize;

        for (var col = rect.left, _i9 = 0; col < rect.right; col++, _i9++) {
          if (col == rect.left && row == rect.top) continue;
          tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), getCellType({
            node: cellNode,
            row: row,
            col: col
          }).createAndFill(attrs[_i9]));
        }
      }

      tr.setNodeMarkup(cellPos, getCellType({
        node: cellNode,
        row: rect.top,
        col: rect.left
      }), attrs[0]);
      if (sel instanceof CellSelection) tr.setSelection(new CellSelection(tr.doc.resolve(sel.$anchorCell.pos), lastCell ? tr.doc.resolve(lastCell) : void 0));
      dispatch(tr);
    }

    return true;
  };
}

function setCellAttr(name, value) {
  return function (state, dispatch) {
    if (!isInTable(state)) return false;
    var $cell = selectionCell(state);
    if ($cell.nodeAfter.attrs[name] === value) return false;

    if (dispatch) {
      var tr = state.tr;
      if (state.selection instanceof CellSelection) state.selection.forEachCell(function (node, pos) {
        if (node.attrs[name] !== value) tr.setNodeMarkup(pos, null, _objectSpread(_objectSpread({}, node.attrs), {}, _defineProperty({}, name, value)));
      });else tr.setNodeMarkup($cell.pos, null, _objectSpread(_objectSpread({}, $cell.nodeAfter.attrs), {}, _defineProperty({}, name, value)));
      dispatch(tr);
    }

    return true;
  };
}

function deprecated_toggleHeader(type) {
  return function (state, dispatch) {
    if (!isInTable(state)) return false;

    if (dispatch) {
      var types = tableNodeTypes(state.schema);
      var rect = selectedRect(state),
          tr = state.tr;
      var cells = rect.map.cellsInRect(type == "column" ? {
        left: rect.left,
        top: 0,
        right: rect.right,
        bottom: rect.map.height
      } : type == "row" ? {
        left: 0,
        top: rect.top,
        right: rect.map.width,
        bottom: rect.bottom
      } : rect);
      var nodes = cells.map(function (pos) {
        return rect.table.nodeAt(pos);
      });

      for (var i = 0; i < cells.length; i++) {
        if (nodes[i].type == types.header_cell) tr.setNodeMarkup(rect.tableStart + cells[i], types.cell, nodes[i].attrs);
      }

      if (tr.steps.length == 0) for (var _i10 = 0; _i10 < cells.length; _i10++) {
        tr.setNodeMarkup(rect.tableStart + cells[_i10], types.header_cell, nodes[_i10].attrs);
      }
      dispatch(tr);
    }

    return true;
  };
}

function isHeaderEnabledByType(type, rect, types) {
  var cellPositions = rect.map.cellsInRect({
    left: 0,
    top: 0,
    right: type == "row" ? rect.map.width : 1,
    bottom: type == "column" ? rect.map.height : 1
  });

  for (var i = 0; i < cellPositions.length; i++) {
    var cell = rect.table.nodeAt(cellPositions[i]);

    if (cell && cell.type !== types.header_cell) {
      return false;
    }
  }

  return true;
}

function toggleHeader(type, options) {
  options = options || {
    useDeprecatedLogic: false
  };
  if (options.useDeprecatedLogic) return deprecated_toggleHeader(type);
  return function (state, dispatch) {
    if (!isInTable(state)) return false;

    if (dispatch) {
      var types = tableNodeTypes(state.schema);
      var rect = selectedRect(state),
          tr = state.tr;
      var isHeaderRowEnabled = isHeaderEnabledByType("row", rect, types);
      var isHeaderColumnEnabled = isHeaderEnabledByType("column", rect, types);
      var isHeaderEnabled = type === "column" ? isHeaderRowEnabled : type === "row" ? isHeaderColumnEnabled : false;
      var selectionStartsAt = isHeaderEnabled ? 1 : 0;
      var cellsRect = type == "column" ? {
        left: 0,
        top: selectionStartsAt,
        right: 1,
        bottom: rect.map.height
      } : type == "row" ? {
        left: selectionStartsAt,
        top: 0,
        right: rect.map.width,
        bottom: 1
      } : rect;
      var newType = type == "column" ? isHeaderColumnEnabled ? types.cell : types.header_cell : type == "row" ? isHeaderRowEnabled ? types.cell : types.header_cell : types.cell;
      rect.map.cellsInRect(cellsRect).forEach(function (relativeCellPos) {
        var cellPos = relativeCellPos + rect.tableStart;
        var cell = tr.doc.nodeAt(cellPos);

        if (cell) {
          tr.setNodeMarkup(cellPos, newType, cell.attrs);
        }
      });
      dispatch(tr);
    }

    return true;
  };
}

var toggleHeaderRow = toggleHeader("row", {
  useDeprecatedLogic: true
});
var toggleHeaderColumn = toggleHeader("column", {
  useDeprecatedLogic: true
});
var toggleHeaderCell = toggleHeader("cell", {
  useDeprecatedLogic: true
});

function findNextCell($cell, dir) {
  if (dir < 0) {
    var before = $cell.nodeBefore;
    if (before) return $cell.pos - before.nodeSize;

    for (var row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--) {
      var rowNode = $cell.node(-1).child(row);
      var lastChild = rowNode.lastChild;

      if (lastChild) {
        return rowEnd - 1 - lastChild.nodeSize;
      }

      rowEnd -= rowNode.nodeSize;
    }
  } else {
    if ($cell.index() < $cell.parent.childCount - 1) {
      return $cell.pos + $cell.nodeAfter.nodeSize;
    }

    var table = $cell.node(-1);

    for (var _row = $cell.indexAfter(-1), rowStart = $cell.after(); _row < table.childCount; _row++) {
      var _rowNode = table.child(_row);

      if (_rowNode.childCount) return rowStart + 1;
      rowStart += _rowNode.nodeSize;
    }
  }

  return null;
}

function goToNextCell(direction) {
  return function (state, dispatch) {
    if (!isInTable(state)) return false;
    var cell = findNextCell(selectionCell(state), direction);
    if (cell == null) return false;

    if (dispatch) {
      var $cell = state.doc.resolve(cell);
      dispatch(state.tr.setSelection(TextSelection2.between($cell, moveCellForward($cell))).scrollIntoView());
    }

    return true;
  };
}

function deleteTable(state, dispatch) {
  var $pos = state.selection.$anchor;

  for (var d = $pos.depth; d > 0; d--) {
    var node = $pos.node(d);

    if (node.type.spec.tableRole == "table") {
      if (dispatch) dispatch(state.tr.delete($pos.before(d), $pos.after(d)).scrollIntoView());
      return true;
    }
  }

  return false;
}

function deleteCellSelection(state, dispatch) {
  var sel = state.selection;
  if (!(sel instanceof CellSelection)) return false;

  if (dispatch) {
    var tr = state.tr;
    var baseContent = tableNodeTypes(state.schema).cell.createAndFill().content;
    sel.forEachCell(function (cell, pos) {
      if (!cell.content.eq(baseContent)) tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1), new Slice2(baseContent, 0, 0));
    });
    if (tr.docChanged) dispatch(tr);
  }

  return true;
} // src/copypaste.ts


import { Fragment as Fragment3, Slice as Slice3 } from "prosemirror-model";
import { Transform } from "prosemirror-transform";

function pastedCells(slice) {
  if (!slice.size) return null;
  var content = slice.content,
      openStart = slice.openStart,
      openEnd = slice.openEnd;

  while (content.childCount == 1 && (openStart > 0 && openEnd > 0 || content.child(0).type.spec.tableRole == "table")) {
    openStart--;
    openEnd--;
    content = content.child(0).content;
  }

  var first = content.child(0);
  var role = first.type.spec.tableRole;
  var schema = first.type.schema,
      rows = [];

  if (role == "row") {
    for (var i = 0; i < content.childCount; i++) {
      var cells = content.child(i).content;
      var left = i ? 0 : Math.max(0, openStart - 1);
      var right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
      if (left || right) cells = fitSlice(tableNodeTypes(schema).row, new Slice3(cells, left, right)).content;
      rows.push(cells);
    }
  } else if (role == "cell" || role == "header_cell") {
    rows.push(openStart || openEnd ? fitSlice(tableNodeTypes(schema).row, new Slice3(content, openStart, openEnd)).content : content);
  } else {
    return null;
  }

  return ensureRectangular(schema, rows);
}

function ensureRectangular(schema, rows) {
  var widths = [];

  for (var i = 0; i < rows.length; i++) {
    var row = rows[i];

    for (var j = row.childCount - 1; j >= 0; j--) {
      var _row$child$attrs = row.child(j).attrs,
          rowspan = _row$child$attrs.rowspan,
          colspan = _row$child$attrs.colspan;

      for (var r = i; r < i + rowspan; r++) {
        widths[r] = (widths[r] || 0) + colspan;
      }
    }
  }

  var width = 0;

  for (var _r = 0; _r < widths.length; _r++) {
    width = Math.max(width, widths[_r]);
  }

  for (var _r2 = 0; _r2 < widths.length; _r2++) {
    if (_r2 >= rows.length) rows.push(Fragment3.empty);

    if (widths[_r2] < width) {
      var empty = tableNodeTypes(schema).cell.createAndFill();
      var cells = [];

      for (var _i11 = widths[_r2]; _i11 < width; _i11++) {
        cells.push(empty);
      }

      rows[_r2] = rows[_r2].append(Fragment3.from(cells));
    }
  }

  return {
    height: rows.length,
    width: width,
    rows: rows
  };
}

function fitSlice(nodeType, slice) {
  var node = nodeType.createAndFill();
  var tr = new Transform(node).replace(0, node.content.size, slice);
  return tr.doc;
}

function clipCells(_ref9, newWidth, newHeight) {
  var width = _ref9.width,
      height = _ref9.height,
      rows = _ref9.rows;

  if (width != newWidth) {
    var added = [];
    var newRows = [];

    for (var row = 0; row < rows.length; row++) {
      var frag = rows[row],
          cells = [];

      for (var col = added[row] || 0, i = 0; col < newWidth; i++) {
        var cell = frag.child(i % frag.childCount);
        if (col + cell.attrs.colspan > newWidth) cell = cell.type.createChecked(removeColSpan(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
        cells.push(cell);
        col += cell.attrs.colspan;

        for (var j = 1; j < cell.attrs.rowspan; j++) {
          added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
        }
      }

      newRows.push(Fragment3.from(cells));
    }

    rows = newRows;
    width = newWidth;
  }

  if (height != newHeight) {
    var _newRows = [];

    for (var _row2 = 0, _i12 = 0; _row2 < newHeight; _row2++, _i12++) {
      var _cells = [],
          source = rows[_i12 % height];

      for (var _j3 = 0; _j3 < source.childCount; _j3++) {
        var _cell4 = source.child(_j3);

        if (_row2 + _cell4.attrs.rowspan > newHeight) _cell4 = _cell4.type.create(_objectSpread(_objectSpread({}, _cell4.attrs), {}, {
          rowspan: Math.max(1, newHeight - _cell4.attrs.rowspan)
        }), _cell4.content);

        _cells.push(_cell4);
      }

      _newRows.push(Fragment3.from(_cells));
    }

    rows = _newRows;
    height = newHeight;
  }

  return {
    width: width,
    height: height,
    rows: rows
  };
}

function growTable(tr, map, table, start, width, height, mapFrom) {
  var schema = tr.doc.type.schema;
  var types = tableNodeTypes(schema);
  var empty;
  var emptyHead;

  if (width > map.width) {
    for (var row = 0, rowEnd = 0; row < map.height; row++) {
      var rowNode = table.child(row);
      rowEnd += rowNode.nodeSize;
      var cells = [];
      var add = void 0;
      if (rowNode.lastChild == null || rowNode.lastChild.type == types.cell) add = empty || (empty = types.cell.createAndFill());else add = emptyHead || (emptyHead = types.header_cell.createAndFill());

      for (var i = map.width; i < width; i++) {
        cells.push(add);
      }

      tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
  }

  if (height > map.height) {
    var _cells2 = [];

    for (var _i13 = 0, start2 = (map.height - 1) * map.width; _i13 < Math.max(map.width, width); _i13++) {
      var header = _i13 >= map.width ? false : table.nodeAt(map.map[start2 + _i13]).type == types.header_cell;

      _cells2.push(header ? emptyHead || (emptyHead = types.header_cell.createAndFill()) : empty || (empty = types.cell.createAndFill()));
    }

    var emptyRow = types.row.create(null, Fragment3.from(_cells2)),
        rows = [];

    for (var _i14 = map.height; _i14 < height; _i14++) {
      rows.push(emptyRow);
    }

    tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
  }

  return !!(empty || emptyHead);
}

function isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
  if (top == 0 || top == map.height) return false;
  var found = false;

  for (var col = left; col < right; col++) {
    var index = top * map.width + col,
        pos = map.map[index];

    if (map.map[index - map.width] == pos) {
      found = true;
      var cell = table.nodeAt(pos);

      var _map$findCell = map.findCell(pos),
          cellTop = _map$findCell.top,
          cellLeft = _map$findCell.left;

      tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), null, _objectSpread(_objectSpread({}, cell.attrs), {}, {
        rowspan: top - cellTop
      }));
      tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), cell.type.createAndFill(_objectSpread(_objectSpread({}, cell.attrs), {}, {
        rowspan: cellTop + cell.attrs.rowspan - top
      })));
      col += cell.attrs.colspan - 1;
    }
  }

  return found;
}

function isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
  if (left == 0 || left == map.width) return false;
  var found = false;

  for (var row = top; row < bottom; row++) {
    var index = row * map.width + left,
        pos = map.map[index];

    if (map.map[index - 1] == pos) {
      found = true;
      var cell = table.nodeAt(pos);
      var cellLeft = map.colCount(pos);
      var updatePos = tr.mapping.slice(mapFrom).map(pos + start);
      tr.setNodeMarkup(updatePos, null, removeColSpan(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
      tr.insert(updatePos + cell.nodeSize, cell.type.createAndFill(removeColSpan(cell.attrs, 0, left - cellLeft)));
      row += cell.attrs.rowspan - 1;
    }
  }

  return found;
}

function insertCells(state, dispatch, tableStart, rect, cells) {
  var table = tableStart ? state.doc.nodeAt(tableStart - 1) : state.doc;

  if (!table) {
    throw new Error("No table found");
  }

  var map = TableMap.get(table);
  var top = rect.top,
      left = rect.left;
  var right = left + cells.width,
      bottom = top + cells.height;
  var tr = state.tr;
  var mapFrom = 0;

  function recomp() {
    table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;

    if (!table) {
      throw new Error("No table found");
    }

    map = TableMap.get(table);
    mapFrom = tr.mapping.maps.length;
  }

  if (growTable(tr, map, table, tableStart, right, bottom, mapFrom)) recomp();
  if (isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) recomp();
  if (isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) recomp();
  if (isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) recomp();
  if (isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) recomp();

  for (var row = top; row < bottom; row++) {
    var from = map.positionAt(row, left, table),
        to = map.positionAt(row, right, table);
    tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new Slice3(cells.rows[row - top], 0, 0));
  }

  recomp();
  tr.setSelection(new CellSelection(tr.doc.resolve(tableStart + map.positionAt(top, left, table)), tr.doc.resolve(tableStart + map.positionAt(bottom - 1, right - 1, table))));
  dispatch(tr);
} // src/input.ts


var handleKeyDown = keydownHandler({
  ArrowLeft: arrow("horiz", -1),
  ArrowRight: arrow("horiz", 1),
  ArrowUp: arrow("vert", -1),
  ArrowDown: arrow("vert", 1),
  "Shift-ArrowLeft": shiftArrow("horiz", -1),
  "Shift-ArrowRight": shiftArrow("horiz", 1),
  "Shift-ArrowUp": shiftArrow("vert", -1),
  "Shift-ArrowDown": shiftArrow("vert", 1),
  Backspace: deleteCellSelection,
  "Mod-Backspace": deleteCellSelection,
  Delete: deleteCellSelection,
  "Mod-Delete": deleteCellSelection
});

function maybeSetSelection(state, dispatch, selection) {
  if (selection.eq(state.selection)) return false;
  if (dispatch) dispatch(state.tr.setSelection(selection).scrollIntoView());
  return true;
}

function arrow(axis, dir) {
  return function (state, dispatch, view) {
    if (!view) return false;
    var sel = state.selection;

    if (sel instanceof CellSelection) {
      return maybeSetSelection(state, dispatch, Selection2.near(sel.$headCell, dir));
    }

    if (axis != "horiz" && !sel.empty) return false;
    var end = atEndOfCell(view, axis, dir);
    if (end == null) return false;

    if (axis == "horiz") {
      return maybeSetSelection(state, dispatch, Selection2.near(state.doc.resolve(sel.head + dir), dir));
    } else {
      var $cell = state.doc.resolve(end);
      var $next = nextCell($cell, axis, dir);
      var newSel;
      if ($next) newSel = Selection2.near($next, 1);else if (dir < 0) newSel = Selection2.near(state.doc.resolve($cell.before(-1)), -1);else newSel = Selection2.near(state.doc.resolve($cell.after(-1)), 1);
      return maybeSetSelection(state, dispatch, newSel);
    }
  };
}

function shiftArrow(axis, dir) {
  return function (state, dispatch, view) {
    if (!view) return false;
    var sel = state.selection;
    var cellSel;

    if (sel instanceof CellSelection) {
      cellSel = sel;
    } else {
      var end = atEndOfCell(view, axis, dir);
      if (end == null) return false;
      cellSel = new CellSelection(state.doc.resolve(end));
    }

    var $head = nextCell(cellSel.$headCell, axis, dir);
    if (!$head) return false;
    return maybeSetSelection(state, dispatch, new CellSelection(cellSel.$anchorCell, $head));
  };
}

function handleTripleClick(view, pos) {
  var doc = view.state.doc,
      $cell = cellAround(doc.resolve(pos));
  if (!$cell) return false;
  view.dispatch(view.state.tr.setSelection(new CellSelection($cell)));
  return true;
}

function handlePaste(view, _, slice) {
  if (!isInTable(view.state)) return false;
  var cells = pastedCells(slice);
  var sel = view.state.selection;

  if (sel instanceof CellSelection) {
    if (!cells) cells = {
      width: 1,
      height: 1,
      rows: [Fragment4.from(fitSlice(tableNodeTypes(view.state.schema).cell, slice))]
    };
    var table = sel.$anchorCell.node(-1);
    var start = sel.$anchorCell.start(-1);
    var rect = TableMap.get(table).rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
    cells = clipCells(cells, rect.right - rect.left, rect.bottom - rect.top);
    insertCells(view.state, view.dispatch, start, rect, cells);
    return true;
  } else if (cells) {
    var $cell = selectionCell(view.state);

    var _start = $cell.start(-1);

    insertCells(view.state, view.dispatch, _start, TableMap.get($cell.node(-1)).findCell($cell.pos - _start), cells);
    return true;
  } else {
    return false;
  }
}

function handleMouseDown(view, startEvent) {
  var _a;

  if (startEvent.ctrlKey || startEvent.metaKey) return;
  var startDOMCell = domInCell(view, startEvent.target);
  var $anchor;

  if (startEvent.shiftKey && view.state.selection instanceof CellSelection) {
    setCellSelection(view.state.selection.$anchorCell, startEvent);
    startEvent.preventDefault();
  } else if (startEvent.shiftKey && startDOMCell && ($anchor = cellAround(view.state.selection.$anchor)) != null && ((_a = cellUnderMouse(view, startEvent)) == null ? void 0 : _a.pos) != $anchor.pos) {
    setCellSelection($anchor, startEvent);
    startEvent.preventDefault();
  } else if (!startDOMCell) {
    return;
  }

  function setCellSelection($anchor2, event) {
    var $head = cellUnderMouse(view, event);
    var starting = tableEditingKey.getState(view.state) == null;

    if (!$head || !inSameTable($anchor2, $head)) {
      if (starting) $head = $anchor2;else return;
    }

    var selection = new CellSelection($anchor2, $head);

    if (starting || !view.state.selection.eq(selection)) {
      var tr = view.state.tr.setSelection(selection);
      if (starting) tr.setMeta(tableEditingKey, $anchor2.pos);
      view.dispatch(tr);
    }
  }

  function stop() {
    view.root.removeEventListener("mouseup", stop);
    view.root.removeEventListener("dragstart", stop);
    view.root.removeEventListener("mousemove", move);
    if (tableEditingKey.getState(view.state) != null) view.dispatch(view.state.tr.setMeta(tableEditingKey, -1));
  }

  function move(_event) {
    var event = _event;
    var anchor = tableEditingKey.getState(view.state);
    var $anchor2;

    if (anchor != null) {
      $anchor2 = view.state.doc.resolve(anchor);
    } else if (domInCell(view, event.target) != startDOMCell) {
      $anchor2 = cellUnderMouse(view, startEvent);
      if (!$anchor2) return stop();
    }

    if ($anchor2) setCellSelection($anchor2, event);
  }

  view.root.addEventListener("mouseup", stop);
  view.root.addEventListener("dragstart", stop);
  view.root.addEventListener("mousemove", move);
}

function atEndOfCell(view, axis, dir) {
  if (!(view.state.selection instanceof TextSelection3)) return null;
  var $head = view.state.selection.$head;

  for (var d = $head.depth - 1; d >= 0; d--) {
    var parent = $head.node(d),
        index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
    if (index != (dir < 0 ? 0 : parent.childCount)) return null;

    if (parent.type.spec.tableRole == "cell" || parent.type.spec.tableRole == "header_cell") {
      var cellPos = $head.before(d);
      var dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
      return view.endOfTextblock(dirStr) ? cellPos : null;
    }
  }

  return null;
}

function domInCell(view, dom) {
  for (; dom && dom != view.dom; dom = dom.parentNode) {
    if (dom.nodeName == "TD" || dom.nodeName == "TH") {
      return dom;
    }
  }

  return null;
}

function cellUnderMouse(view, event) {
  var mousePos = view.posAtCoords({
    left: event.clientX,
    top: event.clientY
  });
  if (!mousePos) return null;
  return mousePos ? cellAround(view.state.doc.resolve(mousePos.pos)) : null;
} // src/columnresizing.ts


import { Plugin, PluginKey as PluginKey3 } from "prosemirror-state";
import { Decoration as Decoration2, DecorationSet as DecorationSet2 } from "prosemirror-view"; // src/tableview.ts

var TableView = /*#__PURE__*/function () {
  function TableView(node, defaultCellMinWidth) {
    _classCallCheck(this, TableView);

    this.node = node;
    this.defaultCellMinWidth = defaultCellMinWidth;
    this.dom = document.createElement("div");
    this.dom.className = "tableWrapper";
    this.table = this.dom.appendChild(document.createElement("table"));
    this.table.style.setProperty("--default-cell-min-width", "".concat(defaultCellMinWidth, "px"));
    this.colgroup = this.table.appendChild(document.createElement("colgroup"));
    updateColumnsOnResize(node, this.colgroup, this.table, defaultCellMinWidth);
    this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }

  _createClass(TableView, [{
    key: "update",
    value: function update(node) {
      if (node.type != this.node.type) return false;
      this.node = node;
      updateColumnsOnResize(node, this.colgroup, this.table, this.defaultCellMinWidth);
      return true;
    }
  }, {
    key: "ignoreMutation",
    value: function ignoreMutation(record) {
      return record.type == "attributes" && (record.target == this.table || this.colgroup.contains(record.target));
    }
  }]);

  return TableView;
}();

function updateColumnsOnResize(node, colgroup, table, defaultCellMinWidth, overrideCol, overrideValue) {
  var _a;

  var totalWidth = 0;
  var fixedWidth = true;
  var nextDOM = colgroup.firstChild;
  var row = node.firstChild;
  if (!row) return;

  for (var i = 0, col = 0; i < row.childCount; i++) {
    var _row$child$attrs2 = row.child(i).attrs,
        colspan = _row$child$attrs2.colspan,
        colwidth = _row$child$attrs2.colwidth;

    for (var j = 0; j < colspan; j++, col++) {
      var hasWidth = overrideCol == col ? overrideValue : colwidth && colwidth[j];
      var cssWidth = hasWidth ? hasWidth + "px" : "";
      totalWidth += hasWidth || defaultCellMinWidth;
      if (!hasWidth) fixedWidth = false;

      if (!nextDOM) {
        var col2 = document.createElement("col");
        col2.style.width = cssWidth;
        colgroup.appendChild(col2);
      } else {
        if (nextDOM.style.width != cssWidth) {
          nextDOM.style.width = cssWidth;
        }

        nextDOM = nextDOM.nextSibling;
      }
    }
  }

  while (nextDOM) {
    var after = nextDOM.nextSibling;
    (_a = nextDOM.parentNode) == null ? void 0 : _a.removeChild(nextDOM);
    nextDOM = after;
  }

  if (fixedWidth) {
    table.style.width = totalWidth + "px";
    table.style.minWidth = "";
  } else {
    table.style.width = "";
    table.style.minWidth = totalWidth + "px";
  }
} // src/columnresizing.ts


var columnResizingPluginKey = new PluginKey3("tableColumnResizing");

function columnResizing() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref10$handleWidth = _ref10.handleWidth,
      handleWidth = _ref10$handleWidth === void 0 ? 5 : _ref10$handleWidth,
      _ref10$cellMinWidth = _ref10.cellMinWidth,
      cellMinWidth = _ref10$cellMinWidth === void 0 ? 25 : _ref10$cellMinWidth,
      _ref10$defaultCellMin = _ref10.defaultCellMinWidth,
      defaultCellMinWidth = _ref10$defaultCellMin === void 0 ? 100 : _ref10$defaultCellMin,
      _ref10$View = _ref10.View,
      View = _ref10$View === void 0 ? TableView : _ref10$View,
      _ref10$lastColumnResi = _ref10.lastColumnResizable,
      lastColumnResizable = _ref10$lastColumnResi === void 0 ? true : _ref10$lastColumnResi;

  var plugin = new Plugin({
    key: columnResizingPluginKey,
    state: {
      init: function init(_, state) {
        var _a, _b;

        var nodeViews = (_b = (_a = plugin.spec) == null ? void 0 : _a.props) == null ? void 0 : _b.nodeViews;
        var tableName = tableNodeTypes(state.schema).table.name;

        if (View && nodeViews) {
          nodeViews[tableName] = function (node, view) {
            return new View(node, defaultCellMinWidth, view);
          };
        }

        return new ResizeState(-1, false);
      },
      apply: function apply(tr, prev) {
        return prev.apply(tr);
      }
    },
    props: {
      attributes: function attributes(state) {
        var pluginState = columnResizingPluginKey.getState(state);
        return pluginState && pluginState.activeHandle > -1 ? {
          class: "resize-cursor"
        } : {};
      },
      handleDOMEvents: {
        mousemove: function mousemove(view, event) {
          handleMouseMove(view, event, handleWidth, lastColumnResizable);
        },
        mouseleave: function mouseleave(view) {
          handleMouseLeave(view);
        },
        mousedown: function mousedown(view, event) {
          handleMouseDown2(view, event, cellMinWidth, defaultCellMinWidth);
        }
      },
      decorations: function decorations(state) {
        var pluginState = columnResizingPluginKey.getState(state);

        if (pluginState && pluginState.activeHandle > -1) {
          return handleDecorations(state, pluginState.activeHandle);
        }
      },
      nodeViews: {}
    }
  });
  return plugin;
}

var ResizeState = /*#__PURE__*/function () {
  function _ResizeState(activeHandle, dragging) {
    _classCallCheck(this, _ResizeState);

    this.activeHandle = activeHandle;
    this.dragging = dragging;
  }

  _createClass(_ResizeState, [{
    key: "apply",
    value: function apply(tr) {
      var state = this;
      var action = tr.getMeta(columnResizingPluginKey);
      if (action && action.setHandle != null) return new _ResizeState(action.setHandle, false);
      if (action && action.setDragging !== void 0) return new _ResizeState(state.activeHandle, action.setDragging);

      if (state.activeHandle > -1 && tr.docChanged) {
        var handle = tr.mapping.map(state.activeHandle, -1);

        if (!pointsAtCell(tr.doc.resolve(handle))) {
          handle = -1;
        }

        return new _ResizeState(handle, state.dragging);
      }

      return state;
    }
  }]);

  return _ResizeState;
}();

function handleMouseMove(view, event, handleWidth, lastColumnResizable) {
  if (!view.editable) return;
  var pluginState = columnResizingPluginKey.getState(view.state);
  if (!pluginState) return;

  if (!pluginState.dragging) {
    var target = domCellAround(event.target);
    var cell = -1;

    if (target) {
      var _target$getBoundingCl = target.getBoundingClientRect(),
          left = _target$getBoundingCl.left,
          right = _target$getBoundingCl.right;

      if (event.clientX - left <= handleWidth) cell = edgeCell(view, event, "left", handleWidth);else if (right - event.clientX <= handleWidth) cell = edgeCell(view, event, "right", handleWidth);
    }

    if (cell != pluginState.activeHandle) {
      if (!lastColumnResizable && cell !== -1) {
        var $cell = view.state.doc.resolve(cell);
        var table = $cell.node(-1);
        var map = TableMap.get(table);
        var tableStart = $cell.start(-1);
        var col = map.colCount($cell.pos - tableStart) + $cell.nodeAfter.attrs.colspan - 1;

        if (col == map.width - 1) {
          return;
        }
      }

      updateHandle(view, cell);
    }
  }
}

function handleMouseLeave(view) {
  if (!view.editable) return;
  var pluginState = columnResizingPluginKey.getState(view.state);
  if (pluginState && pluginState.activeHandle > -1 && !pluginState.dragging) updateHandle(view, -1);
}

function handleMouseDown2(view, event, cellMinWidth, defaultCellMinWidth) {
  var _a;

  if (!view.editable) return false;
  var win = (_a = view.dom.ownerDocument.defaultView) != null ? _a : window;
  var pluginState = columnResizingPluginKey.getState(view.state);
  if (!pluginState || pluginState.activeHandle == -1 || pluginState.dragging) return false;
  var cell = view.state.doc.nodeAt(pluginState.activeHandle);
  var width = currentColWidth(view, pluginState.activeHandle, cell.attrs);
  view.dispatch(view.state.tr.setMeta(columnResizingPluginKey, {
    setDragging: {
      startX: event.clientX,
      startWidth: width
    }
  }));

  function finish(event2) {
    win.removeEventListener("mouseup", finish);
    win.removeEventListener("mousemove", move);
    var pluginState2 = columnResizingPluginKey.getState(view.state);

    if (pluginState2 == null ? void 0 : pluginState2.dragging) {
      updateColumnWidth(view, pluginState2.activeHandle, draggedWidth(pluginState2.dragging, event2, cellMinWidth));
      view.dispatch(view.state.tr.setMeta(columnResizingPluginKey, {
        setDragging: null
      }));
    }
  }

  function move(event2) {
    if (!event2.which) return finish(event2);
    var pluginState2 = columnResizingPluginKey.getState(view.state);
    if (!pluginState2) return;

    if (pluginState2.dragging) {
      var dragged = draggedWidth(pluginState2.dragging, event2, cellMinWidth);
      displayColumnWidth(view, pluginState2.activeHandle, dragged, defaultCellMinWidth);
    }
  }

  displayColumnWidth(view, pluginState.activeHandle, width, defaultCellMinWidth);
  win.addEventListener("mouseup", finish);
  win.addEventListener("mousemove", move);
  event.preventDefault();
  return true;
}

function currentColWidth(view, cellPos, _ref11) {
  var colspan = _ref11.colspan,
      colwidth = _ref11.colwidth;
  var width = colwidth && colwidth[colwidth.length - 1];
  if (width) return width;
  var dom = view.domAtPos(cellPos);
  var node = dom.node.childNodes[dom.offset];
  var domWidth = node.offsetWidth,
      parts = colspan;

  if (colwidth) {
    for (var i = 0; i < colspan; i++) {
      if (colwidth[i]) {
        domWidth -= colwidth[i];
        parts--;
      }
    }
  }

  return domWidth / parts;
}

function domCellAround(target) {
  while (target && target.nodeName != "TD" && target.nodeName != "TH") {
    target = target.classList && target.classList.contains("ProseMirror") ? null : target.parentNode;
  }

  return target;
}

function edgeCell(view, event, side, handleWidth) {
  var offset = side == "right" ? -handleWidth : handleWidth;
  var found = view.posAtCoords({
    left: event.clientX + offset,
    top: event.clientY
  });
  if (!found) return -1;
  var pos = found.pos;
  var $cell = cellAround(view.state.doc.resolve(pos));
  if (!$cell) return -1;
  if (side == "right") return $cell.pos;
  var map = TableMap.get($cell.node(-1)),
      start = $cell.start(-1);
  var index = map.map.indexOf($cell.pos - start);
  return index % map.width == 0 ? -1 : start + map.map[index - 1];
}

function draggedWidth(dragging, event, resizeMinWidth) {
  var offset = event.clientX - dragging.startX;
  return Math.max(resizeMinWidth, dragging.startWidth + offset);
}

function updateHandle(view, value) {
  view.dispatch(view.state.tr.setMeta(columnResizingPluginKey, {
    setHandle: value
  }));
}

function updateColumnWidth(view, cell, width) {
  var $cell = view.state.doc.resolve(cell);
  var table = $cell.node(-1),
      map = TableMap.get(table),
      start = $cell.start(-1);
  var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  var tr = view.state.tr;

  for (var row = 0; row < map.height; row++) {
    var mapIndex = row * map.width + col;
    if (row && map.map[mapIndex] == map.map[mapIndex - map.width]) continue;
    var pos = map.map[mapIndex];
    var attrs = table.nodeAt(pos).attrs;
    var index = attrs.colspan == 1 ? 0 : col - map.colCount(pos);
    if (attrs.colwidth && attrs.colwidth[index] == width) continue;
    var colwidth = attrs.colwidth ? attrs.colwidth.slice() : zeroes(attrs.colspan);
    colwidth[index] = width;
    tr.setNodeMarkup(start + pos, null, _objectSpread(_objectSpread({}, attrs), {}, {
      colwidth: colwidth
    }));
  }

  if (tr.docChanged) view.dispatch(tr);
}

function displayColumnWidth(view, cell, width, defaultCellMinWidth) {
  var $cell = view.state.doc.resolve(cell);
  var table = $cell.node(-1),
      start = $cell.start(-1);
  var col = TableMap.get(table).colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  var dom = view.domAtPos($cell.start(-1)).node;

  while (dom && dom.nodeName != "TABLE") {
    dom = dom.parentNode;
  }

  if (!dom) return;
  updateColumnsOnResize(table, dom.firstChild, dom, defaultCellMinWidth, col, width);
}

function zeroes(n) {
  return Array(n).fill(0);
}

function handleDecorations(state, cell) {
  var _a;

  var decorations = [];
  var $cell = state.doc.resolve(cell);
  var table = $cell.node(-1);

  if (!table) {
    return DecorationSet2.empty;
  }

  var map = TableMap.get(table);
  var start = $cell.start(-1);
  var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;

  for (var row = 0; row < map.height; row++) {
    var index = col + row * map.width;

    if ((col == map.width - 1 || map.map[index] != map.map[index + 1]) && (row == 0 || map.map[index] != map.map[index - map.width])) {
      var cellPos = map.map[index];
      var pos = start + cellPos + table.nodeAt(cellPos).nodeSize - 1;
      var dom = document.createElement("div");
      dom.className = "column-resize-handle";

      if ((_a = columnResizingPluginKey.getState(state)) == null ? void 0 : _a.dragging) {
        decorations.push(Decoration2.node(start + cellPos, start + cellPos + table.nodeAt(cellPos).nodeSize, {
          class: "column-resize-dragging"
        }));
      }

      decorations.push(Decoration2.widget(pos, dom));
    }
  }

  return DecorationSet2.create(state.doc, decorations);
} // src/index.ts


function tableEditing() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref12$allowTableNode = _ref12.allowTableNodeSelection,
      allowTableNodeSelection = _ref12$allowTableNode === void 0 ? false : _ref12$allowTableNode;

  return new Plugin2({
    key: tableEditingKey,
    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init: function init() {
        return null;
      },
      apply: function apply(tr, cur) {
        var set = tr.getMeta(tableEditingKey);
        if (set != null) return set == -1 ? null : set;
        if (cur == null || !tr.docChanged) return cur;

        var _tr$mapping$mapResult = tr.mapping.mapResult(cur),
            deleted = _tr$mapping$mapResult.deleted,
            pos = _tr$mapping$mapResult.pos;

        return deleted ? null : pos;
      }
    },
    props: {
      decorations: drawCellSelection,
      handleDOMEvents: {
        mousedown: handleMouseDown
      },
      createSelectionBetween: function createSelectionBetween(view) {
        return tableEditingKey.getState(view.state) != null ? view.state.selection : null;
      },
      handleTripleClick: handleTripleClick,
      handleKeyDown: handleKeyDown,
      handlePaste: handlePaste
    },
    appendTransaction: function appendTransaction(_, oldState, state) {
      return normalizeSelection(state, fixTables(state, oldState), allowTableNodeSelection);
    }
  });
}

export { CellBookmark, CellSelection, ResizeState, TableMap, TableView, clipCells as __clipCells, insertCells as __insertCells, pastedCells as __pastedCells, addColSpan, addColumn, addColumnAfter, addColumnBefore, addRow, addRowAfter, addRowBefore, cellAround, cellNear, colCount, columnIsHeader, columnResizing, columnResizingPluginKey, deleteCellSelection, deleteColumn, deleteRow, deleteTable, findCell, fixTables, fixTablesKey, goToNextCell, handlePaste, inSameTable, isInTable, mergeCells, moveCellForward, nextCell, pointsAtCell, removeColSpan, removeColumn, removeRow, rowIsHeader, selectedRect, selectionCell, setCellAttr, splitCell, splitCellWithType, tableEditing, tableEditingKey, tableNodeTypes, tableNodes, toggleHeader, toggleHeaderCell, toggleHeaderColumn, toggleHeaderRow, updateColumnsOnResize };